// extracted by mini-css-extract-plugin
export default {"searchSuggestionBlock":"SearchSuggestionBlock_searchSuggestionBlock__JPgDT","content":"SearchSuggestionBlock_content__ppv4V"};